import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, Typography, Grid, Divider, Backdrop } from '@material-ui/core';
import PageTitle from '../../components/ui/PageTitleUI';
import ButtonUI from '../../components/ui/ButtonUI';
import DateField from '../../components/Form/Date';
import { useStyles } from '../../utils/DefaultStyles';
import { useTranslation } from 'react-i18next';
import {
    Search as SearchIcon,
    BackspaceOutlined as BackspaceOutlinedIcon
} from '@material-ui/icons';
import { useAuth } from '../../hooks/auth';
import { useSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import MvmApi from '../../services/MvmApi';
import { parseISO } from 'date-fns';
import { CircularProgress } from '@mui/material';
import { format } from 'date-fns';
import permissions from '../../utils/Permissions';

interface IFormInput {
    startDate: Date | null;
    endDate: Date | null;
}

const MvmGeneralData: React.FC = () => {
    const classes = useStyles();
    const [dateStart, setDateStart] = useState<Date | null>(null);
    const [dateEnd, setDateEnd] = useState<Date | null>(null);
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation("Reports");
    const { t: _t } = useTranslation("General");
    const { user, hasPermission } = useAuth();
    const history = useHistory();
    const { enqueueSnackbar } = useSnackbar();
    const { handleSubmit, reset, control, watch } = useForm<IFormInput>(
        {
            defaultValues: {
                startDate: null,
                endDate: null
             }
        });


    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (!hasPermission(permissions.REPORTS.MvmGeneralData))
            history.replace('/NoPermission');
    }, [user, history]);

    const watchStartDate = watch('startDate');
    const watchEndDate = watch('endDate');
    
    useEffect(() => {
        setDateStart(parseISO(watchStartDate?.toString() ?? "2001-01-01"));
    }, [watchStartDate]);

    useEffect(() => {
        setDateEnd(parseISO(watchEndDate?.toString() ?? format(new Date(), 'yyyy-MM-dd')));
    }, [watchEndDate]);

    
    const onSubmit = (data: any) => {
        setLoading(true);

        MvmApi.exportMvmGeneralData(user.company.plantID, data.startDate, data.endDate)
        .catch((err) => {
            if (err !== "")
                enqueueSnackbar(err, { variant: 'error' });
            else
                enqueueSnackbar(t("mvmGeneralData.exportError"), { variant: 'error' })
        }).finally(() => {
            setLoading(false);
        });
    }

    return (
        <Container maxWidth={false} component="main">
            <Backdrop style={{ zIndex: 9999 }} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            
            <PageTitle title={t("mvmGeneralData.pageTitle")} />

            <div className={classes.rootContent}>
                <div className={classes.paper}>
                    <form onSubmit={handleSubmit(onSubmit)} >
                        <Grid container spacing={1}>
                            <Grid item xs={6} style={{ padding: "0px", display: 'flex', alignItems: 'center' }}>
                                <Typography className={classes.root}>
                                    {_t("search")}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} style={{ padding: "0px", textAlign: 'right' }}>
                                <ButtonUI onClick={() => reset()} startIcon={<BackspaceOutlinedIcon />}>{_t("clean")}</ButtonUI>
                                <ButtonUI type="submit" color="primary" startIcon={<SearchIcon />}>{_t("export")}</ButtonUI>
                            </Grid>
                        </Grid>
                        <Divider style={{ marginTop: '10px' }} />
                        <Grid container spacing={1}>
                            <Grid item xs={2}>
                                <DateField label={t("mvmGeneralData.startDate")} name="startDate" control={control} InputLabelProps={{shrink:true}} maxDate={dateEnd ?? new Date()} required fullWidth/>
                            </Grid>

                            <Grid item xs={2}>
                                <DateField label={t("mvmGeneralData.endDate")} name="endDate" control={control} InputLabelProps={{shrink:true}} minDate={dateStart} required fullWidth/>
                            </Grid>
                        </Grid>
                    </form>

                </div>
            </div>
        </Container>
    )
}
export default MvmGeneralData;
